import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    isActive: false,
  },
  reducers: {
    startSession: (state) => {
      state.isActive = true;
    },
    endSession: (state) => {
      state.isActive = false;
    },
  },
});

export const { startSession, endSession } = sessionSlice.actions;
export default sessionSlice.reducer;